import {type ICarrierAdminAuthorizationConfig} from 'shared/Header/components/data'

export interface ICarrierAdminMHPageAccessRights {
    OfferMenu: string
    ManageMHSpotRATEOffers: string
    ViewMHSPOTofferqueue: string
    Marketplace: string
    Booking: string
    SearchAvailabilityAndPrice: string
    SearchAvailableSpace: string
    SearchAirWaybillStock: string
    CreateModifyBookingNew: string
    CreateModifyBookingOld: string
    CreateMultipleBookings: string
    CreateModifyBookingTemplates: string
    CreateSpreadsheetBookings: string
    CreateAirWaybillStockRequest: string
    CreateAllotmentRequest: string
    ViewAllotmentStatus: string
    ViewRateEstimate: string
    ViewCarrierSchedules: string
    UpdateAirWaybillStatus: string
    Efreight: string
    CreateRetrieveMAWB: string
    CreateModifyHAWB: string
    CreateModifyHAWBTemplates: string
    CreateModifyPieceIDInfo: string
    ManageShipments: string
    TrackShipments: string
    SearchAirWaybills: string
    ViewModifyBooking: string
    ReviewActiveQueuedBookings: string
    PrintBarcodeShippingLabel: string
    PrintShipperLetterOfInstruction: string
    MakeOnlinePayments: string
    ViewFlightStatus: string
    ViewCustomsStatus: string
    ViewArchivedAirWaybill: string
    ShipmentReleaseDeclaration: string
    eClaims: string
    FileDamageReport: string
    ViewDamageReportStatus: string
    CreateModifyPreliminaryClaim: string
    CreateModifyFinalClaim: string
}

const CarrierAdminMH = () => {
    const carrierAdminMHConfigKey1: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminMHValue1: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // Create more CarrierAdminAuthorizationConfig instances for other configurations

    const carrierAdminMHConfigKey2: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminMHValue2: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey3: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminMHValue3: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey4: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminMHValue4: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey5: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminMHValue5: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey6: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminMHValue6: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey7: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminMHValue7: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey8: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminMHValue8: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // AministratorStatus denied

    const carrierAdminMHConfigKey9: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminMHValue9: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey10: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminMHValue10: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey11: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminMHValue11: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey12: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminMHValue12: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey13: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminMHValue13: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey14: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminMHValue14: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey15: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminMHValue15: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey16: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminMHValue16: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'Y',
        ViewMHSPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // GSA Status Denied

    const carrierAdminMHConfigKey17: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: false,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminMHValue17: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'N',
        ViewMHSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminMHConfigKey18: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: false,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminMHValue18: ICarrierAdminMHPageAccessRights = {
        OfferMenu: 'Y',
        ManageMHSpotRATEOffers: 'N',
        ViewMHSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const adminHashMap = new Map<ICarrierAdminAuthorizationConfig, ICarrierAdminMHPageAccessRights>()
    adminHashMap.set(carrierAdminMHConfigKey1, carrierAdminMHValue1)
    adminHashMap.set(carrierAdminMHConfigKey2, carrierAdminMHValue2)
    adminHashMap.set(carrierAdminMHConfigKey3, carrierAdminMHValue3)
    adminHashMap.set(carrierAdminMHConfigKey4, carrierAdminMHValue4)
    adminHashMap.set(carrierAdminMHConfigKey5, carrierAdminMHValue5)
    adminHashMap.set(carrierAdminMHConfigKey6, carrierAdminMHValue6)
    adminHashMap.set(carrierAdminMHConfigKey7, carrierAdminMHValue7)
    adminHashMap.set(carrierAdminMHConfigKey8, carrierAdminMHValue8)
    adminHashMap.set(carrierAdminMHConfigKey9, carrierAdminMHValue9)
    adminHashMap.set(carrierAdminMHConfigKey10, carrierAdminMHValue10)
    adminHashMap.set(carrierAdminMHConfigKey11, carrierAdminMHValue11)
    adminHashMap.set(carrierAdminMHConfigKey12, carrierAdminMHValue12)
    adminHashMap.set(carrierAdminMHConfigKey13, carrierAdminMHValue13)
    adminHashMap.set(carrierAdminMHConfigKey14, carrierAdminMHValue14)
    adminHashMap.set(carrierAdminMHConfigKey15, carrierAdminMHValue15)
    adminHashMap.set(carrierAdminMHConfigKey16, carrierAdminMHValue16)
    adminHashMap.set(carrierAdminMHConfigKey17, carrierAdminMHValue17)
    adminHashMap.set(carrierAdminMHConfigKey18, carrierAdminMHValue18)

    return adminHashMap
}
export default CarrierAdminMH
